
export const ACTION_TOOL_BOOK_STATEMENT_COLLEGE_TOTAL_DETAIL = 'ACTION_TOOL_BOOK_STATEMENT_COLLEGE_TOTAL_DETAIL';
export const ACTION_TOOL_BOOK_STATEMENT_DETAIL_MODEL = 'ACTION_TOOL_BOOK_STATEMENT_DETAIL_MODEL';



// WEBPACK FOOTER //
// ./src/store/Admin/modules/settlementMoney/types.js